import React, { useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
import "../css/quiz-related.css";
import QuizRegister from "./QuizRegister";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { setQuizUser } from "../../StudentQuiz/redux/studentQuiz";
import { useDispatch } from "react-redux";

const QuizLogin = () => {
  const [option, setOption] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // ✅ NEW
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/auth/login", { email, password });
      if (res.data.user.role !== "user") {
        alert("Only users allowed");
        return;
      }
      dispatch(setQuizUser(res.data));
      navigate("/quizNew/dashboard");
    } catch (err) {
      alert("Login failed");
    }
  };

  const handleRegister = () => setOption(2);

  return (
    <div className="login-container-1">
      {option === 1 ? (
        <div className="login-card">
          <h2 className="login-title">User Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="">
              <div className="input-group">
                <img
                  src="https://img.icons8.com/ios-glyphs/30/new-post.png"
                  alt="email icon"
                  className="input-icon"
                />
                <input
                  type="email"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input-1"
                />
              </div>
              {/* <div className="input-group">
                  <img
                    src="https://img.icons8.com/ios-glyphs/30/new-post.png"
                    alt="email icon"
                    className="input-icon"
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input-1"
                  />
                </div> */}

              {/* <input
                type="email"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
              /> */}
            </div>

            {/* ✅ Password field with toggle */}
            <div className="" style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                // title="Enter your password"
              />
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#2563eb",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </span>
            </div>

            <button type="submit" className="btn-1 btn-primary-1 w-full mt-20">
              Login
            </button>
          </form>

          <div className="text-center mt-3">
            <p className="text-16">
              You don't have an account{" "}
              <a
                className="text-primary"
                href="#"
                style={{ textDecoration: "underline" }}
                onClick={handleRegister}
              >
                Register
              </a>{" "}
              here.
            </p>
          </div>
        </div>
      ) : (
        <QuizRegister />
      )}
    </div>
  );
};

export default QuizLogin;
